import React, { createContext, useContext } from "react";
import { defaultDoubtSession, type DoubtSession } from "./doubtSession";

const DoubtContext = createContext<DoubtSession>(defaultDoubtSession);

export const DoubtProvider = ({
  session,
  children,
}: {
  session: DoubtSession;
  children: React.ReactNode;
}) => <DoubtContext.Provider value={session}>{children}</DoubtContext.Provider>;

export const useDoubtData = (): DoubtSession => useContext(DoubtContext);
